<template>
    <v-dialog
        v-model="isDialogOpen"
        width="550"
    >
        <v-card>
            <v-toolbar
                flat
            >
                <v-toolbar-title class="pl-6 text-center">
                    <span class="font-weight-bold">{{ $t('drugEffectOnProblem') }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn
                        icon
                        @click.native="$emit('close')"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col class="px-0 px-md-16 text-center">
                        <span class="font-weight-medium">
                            {{ `${$t('productEnumDialogMessage')} ${productName}` }}
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="selectedAttributes.length > 0">
                        <div v-for="(attribute, idx) in selectedAttributes" :key="idx">
                            <span>{{attribute.label}}</span>
                            <ol v-if="attribute.valuesData.length > 0">
                                <li :class="{'teal--text font-weight-bold': inProduct(attributeValue.system_name)}"  v-for="(attributeValue, idx) in attribute.valuesData" :key="idx">{{attributeValue.name}}</li>
                            </ol>
                        </div>
                    </v-col>
                    <v-col v-else>
                        <span>{{ $t('notFound') }}</span>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogRemote from "../../mixins/DialogRemote";

export default {
    name: "ProductEnumAttributesDialog",
    mixins: [ DialogRemote ],
    props: ['productName', 'productEnumAttributes', 'selectedAttributes'],
    methods:{
        inProduct(problemSystemName) {
            if(this.productEnumAttributes !== undefined) {
                const idx = this.productEnumAttributes.findIndex(item=>{
                    return item.value_system_name === problemSystemName
                });
                return idx >= 0;
            }
            return false;
        }
    }
}
</script>

<style scoped>

</style>
